export function fmtCurrency(v, { decimals = 0 } = {}) {
  if (v === null || v === undefined) return "\u2014";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(v);
}

export function fmtCompact(v) {
  if (v === null || v === undefined) return "\u2014";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(v);
}

export function fmtSignedCompact(v) {
  if (v === null || v === undefined) return "\u2014";
  return `${v >= 0 ? "+" : "\u2212"}${fmtCompact(Math.abs(v))}`;
}

export function fmtPct(v) {
  if (v === null || v === undefined) return "\u2014";
  return `${(v * 100).toFixed(1)}%`;
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function fmtPeriod(p) {
  if (!p) return "";
  const [y, m] = p.split("-");
  return `${MONTHS[parseInt(m, 10) - 1]} ${y}`;
}

export function fmtPeriodShort(p) {
  if (!p) return "";
  const [y, m] = p.split("-");
  return `${MONTHS[parseInt(m, 10) - 1]} '${y.slice(2)}`;
}

export function buildPeriodOptions(periods, latest, docMonths = []) {
  if (!periods || periods.length === 0) return [];
  const docs = new Set(docMonths);
  const opts = [];
  const n = periods.length;
  opts.push({ value: `${latest}|${latest}`, label: `Latest Month \u2014 ${fmtPeriod(latest)}${docs.has(latest) ? "  \u25CF docs" : ""}` });
  if (n >= 3) opts.push({ value: `${periods[n - 3]}|${latest}`, label: "Last 3 Months" });
  if (n >= 6) opts.push({ value: `${periods[n - 6]}|${latest}`, label: "Last 6 Months" });
  if (n >= 12) opts.push({ value: `${periods[n - 12]}|${latest}`, label: "Trailing 12 Months" });
  const year = latest.split("-")[0];
  const ytdStart = periods.find((p) => p.startsWith(year));
  if (ytdStart && ytdStart !== latest) opts.push({ value: `${ytdStart}|${latest}`, label: `Year to Date ${year}` });
  opts.push({ value: `${periods[0]}|${latest}`, label: "All Time" });
  opts.push({ value: "__divider__", label: "\u2014 Single Month \u2014", disabled: true });
  [...periods].reverse().forEach((p) => opts.push({ value: `${p}|${p}`, label: `${fmtPeriod(p)}${docs.has(p) ? "  \u25CF docs" : ""}` }));
  return opts;
}
